import React, { useState, useEffect } from 'react';
import { postAPI } from '../../../app/api';
import Swal from 'sweetalert2';

const SendSMS = () => {
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState('');
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);
    const [showTemplates, setShowTemplates] = useState(false);
    const [templateId, setTemplateId] = useState('');

    useEffect(() => {
        fetchGroups();
    }, []);

    const fetchGroups = async () => {
        try {
            const response = await postAPI('communication-group/list', {});
            if (response?.status === 1) {
                setGroups(response?.data?.filter(g => g.status === 1) || []);
            }
        } catch (error) {
            console.error('Error fetching groups:', error);
        }
    };

    // Message templates that work with DLT restrictions
    const messageTemplates = [
         {
            name: "Picnic Invitation",
            template: "BE College Ex Students Club invites you & family for a picnic on {#var#} at {#var#}. Kindly enroll soon. Contact: {#var#}",
            templateId: "1707177035528029887"
        },
        
        {
            name: "Welcome Message",
            template: "123456 is the OTP (One Time Password) for ShikshaPrime (valid for 10 mins). Please do not share this with others. -ShikshaPrime (a RetechPrime initiative)",
            templateId: "1707175389453227208"
        },
        {
            name: "Event Reminder",
            template: "987654 is the OTP (One Time Password) for ShikshaPrime (valid for 10 mins). Please do not share this with others. -ShikshaPrime (a RetechPrime initiative)",
            templateId: "1707175389453227208"
        },
        {
            name: "General Notification",
            template: "555777 is the OTP (One Time Password) for ShikshaPrime (valid for 10 mins). Please do not share this with others. -ShikshaPrime (a RetechPrime initiative)",
            templateId: "1707175389453227208"
        }
    ];

     const applyTemplate = (template, templateIdValue = '') => {
        setMessage(template);
       
        setTemplateId(templateIdValue);
        setShowTemplates(false);
    };

    const handleSendSMS = async () => {
        if (!selectedGroup) {
            Swal.fire('Validation', 'Please select a group', 'warning');
            return;
        }

        if (!message.trim()) {
            Swal.fire('Validation', 'Please enter SMS message', 'warning');
            return;
        }

       

        const result = await Swal.fire({
            title: 'Confirm Send',
            text: 'Are you sure you want to send this SMS to all group members?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Send SMS',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                setSending(true);
                const response = await postAPI('sms/send', {
                    group_id: selectedGroup,
                    message: message,
                    sent_by: 'admin',
                    template_id: templateId || undefined
                });

                if (response?.status === 1) {
                    Swal.fire({
                        title: 'SMS Sent Successfully!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                    setSelectedGroup('');
                    setMessage('');
                    setTemplateId('');
                } else {
                    Swal.fire('Error', response?.msg || 'Failed to send SMS', 'error');
                }
            } catch (error) {
                console.error('Error sending SMS:', error);
                Swal.fire('Error', 'Failed to send SMS', 'error');
            } finally {
                setSending(false);
            }
        }
    };

    return (
        <div className='card send-group-message'>
            <div className='card-body'>
                <div className='form-group mb-3'>
                    <label>Select Group *</label>
                    <select
                        className='form-control'
                        value={selectedGroup}
                        onChange={(e) => setSelectedGroup(e.target.value)}
                        disabled={sending}
                    >
                        <option value="">-- Select Group --</option>
                        <option value="universal">📢 Universal Group (All Members)</option>
                        {groups.map((group) => (
                            <option key={group.id} value={group.id}>
                                {group.group_name} ({group.member_count} members)
                            </option>
                        ))}
                    </select>
                </div>
                
                 <div className='form-group mb-3'>
                    <label>Template ID (Optional)</label>
                    <input
                        type="text"
                        className='form-control'
                        placeholder='Enter DLT Template ID (leave blank to use default: 1707177046844707498)'
                        value={templateId}
                        onChange={(e) => setTemplateId(e.target.value)}
                        disabled={sending}
                    />
                    <small className='text-muted'>
                        Enter a custom DLT Template ID or leave blank to use the default template.
                    </small>
                </div>
                
                <div className='form-group mb-3'>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <label>SMS Message * </label>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-info"
                            onClick={() => setShowTemplates(!showTemplates)}
                            disabled={sending}
                        >
                            📋 Use Template
                        </button>
                    </div>

                    {showTemplates && (
                        <div className="alert alert-info p-2 mb-2">
                            <small><strong>📢 Important:</strong> Only OTP format messages work due to DLT restrictions. Replace the 6-digit number with your custom information:</small>
                            <div className="mt-2">
                                {messageTemplates.map((template, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className="btn btn-sm btn-light me-2 mb-1"
                                         onClick={() => applyTemplate(template.template, template.templateId)}
                                        disabled={sending}
                                    >
                                        {template.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    <textarea
                        placeholder='Enter your SMS message here... Note: Only OTP format works due to DLT restrictions. Use template for best results.'
                        className='form-control'
                        style={{ minHeight: '150px' }}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        disabled={sending}
                        maxLength={500}
                    ></textarea>
                    <small className='text-muted'>
                        {message.length} characters
                    </small>

                    <div className="alert alert-warning mt-2 p-2">
                        <small>
                            <strong>⚠️ DLT Restriction:</strong> Only messages following the OTP format will be delivered.
                            Replace the 6-digit number (123456) with meaningful information like membership ID, event code, etc.
                        </small>
                    </div>
                </div>
                <div>
                    <button
                        className='btn btn-primary'
                        onClick={handleSendSMS}
                        disabled={sending}
                    >
                        {sending ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Sending...
                            </>
                        ) : (
                            'Send SMS'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SendSMS;